<template>
  <div class="modal fade update-user-modal" id="UpdateServiceModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Editar serviço</h1>
          <button type="button" class="btn-close update-user-modal" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <form ref="formUpdateService" @submit.prevent="updateServiceMethod" class="d-flex flex-column overflow-hidden" style="min-height: 0;">
          <div class="modal-body ps-30 pe-30">
            <p>Preencha as informações abaixo para atualizar o serviço</p>

            <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
              <label for="name_service_update" class="form-label fw-medium">Serviço</label>
              <input v-model="service_name" type="text" class="form-control" id="name_service_update" required />
            </div>

            <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
              <label for="category_update" class="form-label fw-medium">Categoria</label>
              <select v-model="selectedCategory" id="category_update" class="form-select" required @change="onCategoryChange">
                <option disabled value="">Selecione a categoria</option>
                <option v-for="cat in getCategories" :key="cat.id" :value="cat.id">
                  {{ cat.name }}
                </option>
              </select>
            </div>

            <div v-if="availableSubcategories.length" class="mb-15 mb-md-20 col-12 mt-30">
              <label for="subcategory_update" class="form-label fw-medium">Subcategoria</label>
              <select v-model="selectedSubcategory" id="subcategory_update" class="form-select" required>
                <option disabled value="">Selecione a subcategoria</option>
                <option v-for="subcategory in availableSubcategories" :key="subcategory.id" :value="subcategory.id">
                  {{ subcategory.name }}
                </option>
              </select>
            </div>

            <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
              <label for="service_value" class="form-label fw-medium">Valor</label>
              <input v-model="service_value" type="text" class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                id="service_value" autocomplete="off" @input="maskMoney" placeholder="Exemplo: 1.150,00" required />
            </div>

            <div class="mb-15 mb-md-20 col-12 mt-30">
              <label for="price_type_update" class="form-label fw-medium">Tipo do valor</label>
              <select id="price_type_update" v-model="price_type" class="form-select">
                <option value="FIXED">Valor fixo</option>
                <option value="STARTING_AT">A partir de</option>
              </select>
            </div>

            <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
              <label for="name_service_created" class="form-label fw-medium">Tempo de execução do serviço</label>
              <input v-model="service_time" type="text" class="form-control shadow-none text-black fs-md-15 fs-lg-16"
                id="service_time" placeholder="HH:MM" @input="maskTime" maxlength="5" autocomplete="off" required />
            </div>

            <div class="mb-20 col-12">
              <label class="form-label fw-medium">Usuários que prestam este serviço</label>

              <div v-if="availableUsers.length" class="border rounded-2 p-15" style="max-height: 260px; overflow-y: auto;">
                <div
                  v-for="user in availableUsers"
                  :key="user.id"
                  class="form-check mb-12"
                >
                  <input
                    :id="`update-service-user-${user.id}`"
                    v-model="selectedUserIds"
                    :value="user.id"
                    class="form-check-input"
                    type="checkbox"
                  />
                  <label class="form-check-label d-block" :for="`update-service-user-${user.id}`">
                    <span class="fw-medium text-black-emphasis">{{ user.name }}</span>
                    <small class="d-block text-body-tertiary">{{ user.email || user.phone || 'Sem contato cadastrado' }}</small>
                  </label>
                </div>
              </div>

              <div v-else class="border rounded-2 p-15 text-body-tertiary">
                Nenhum usuário disponível para vincular.
              </div>
            </div>

            <DepositConfigurationForm :key="getCurrentUpdateService?.id" v-model="deposit_configuration" :price-type="price_type" :users="availableUsers" :user-ids="selectedUserIds" />
            <div class="col-12">
              <div id="alertResponseApiUpdateService"
                class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive"
                aria-atomic="true">
                <div class="d-flex">
                  <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdateService">
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger update-user-modal" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" ref="buttonUpdateService" class="btn btn-success">Salvar serviço</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import DepositConfigurationForm from './DepositConfigurationForm.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { DepositConfigurationForm },
  name: "UpdateServiceModal",
  data() {
    return {
      deposit_configuration: null,
      service_name: "",
      selectedCategory: "",
      selectedSubcategory: "",
      price_type: "FIXED",
      service_value: "",
      service_time: "",
      selectedUserIds: []
    }
  },
  computed: {
    ...mapGetters([
      "getRolesList",
      "getCurrentUpdateService",
      "getOperations",
      "getCategories",
      "getSubcategories",
      "getAllUsersList"
    ]),
    availableUsers() {
      const allUsersList = this.getAllUsersList;
      return Array.isArray(allUsersList) ? allUsersList : [];
    },
    availableSubcategories() {
      return (this.getSubcategories || []).filter(
        (subcategory) => String(subcategory.category_id) === String(this.selectedCategory)
      );
    }
  },
  watch: {
    getCurrentUpdateService: {
      immediate: true,
      async handler(service) {
        if (service) {
          this.deposit_configuration = service.deposit_configuration || null;
          this.service_name = service.name;
          this.selectedCategory = service.category ? service.category.id : (service.category_id || "");
          await this.fetchSubcategories({ category_id: this.selectedCategory, active_only: true });
          this.selectedSubcategory = service.subcategory_id || service.subcategory?.id || "";
          this.price_type = service.price_type || "FIXED";
          this.service_time = service.time ? service.time.substring(0, 5) : ""; // HH:mm
          this.service_value = service.price_formatted;
          this.selectedUserIds = this.extractServiceUserIds(service);
        }
      }
    }
  },
  methods: {
    ...mapActions(["fetchSubcategories"]),
    async onCategoryChange() {
      this.selectedSubcategory = "";
      await this.fetchSubcategories({ category_id: this.selectedCategory, active_only: true });
    },
    extractServiceUserIds(service) {
      if (!service) {
        return [];
      }

      if (Array.isArray(service.users_services)) {
        return service.users_services
          .map((item) => item.user_id ?? item.user?.id)
          .filter((userId) => typeof userId === 'number');
      }

      if (Array.isArray(service.users)) {
        return service.users
          .map((user) => user?.id)
          .filter((userId) => typeof userId === 'number');
      }

      return [];
    },
    changeInformationInputs(element) {
      this.$refs[element].style.borderColor = "#dedee4";
    },
    maskTime() {
      let value = this.service_time.replace(/\D/g, '');

      // Limita a 4 números (HHMM)
      value = value.slice(0, 4);

      let hours = value.slice(0, 2);
      let minutes = value.slice(2, 4);

      if (hours.length === 2 && parseInt(hours) > 23) {
        hours = '23';
      }

      if (minutes.length === 2 && parseInt(minutes) > 59) {
        minutes = '59';
      }

      if (value.length > 2) {
        this.service_time = `${hours}:${minutes}`;
      } else {
        this.service_time = hours;
      }
    },
    maskMoney(e) {
      let value = e.target.value;

      value = value.replace(/\D/g, "");

      if (!value) {
        this.service_value = "";
        return;
      }

      value = (parseInt(value, 10) / 100).toFixed(2);

      value = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);

      this.service_value = value;
    },
    updateServiceMethod() {
      const alertResponse = this.alertResponse;

      const category_id = this.selectedCategory;
      const service_id = this.getCurrentUpdateService.id;
      const service_name = this.service_name;
      const service_value = this.service_value;
      const service_time = this.service_time;
      const user_ids = this.selectedUserIds;

      if (
        category_id == "" ||
        service_id == "" ||
        service_name == "" ||
        service_value == "" ||
        service_time == ""
      ) {
        this.alertResponse("Por favor preencha todos os campos", true);
        return;
      }

      const objServiceUpdate = {
        category_id: Number(category_id),
        subcategory_id: this.selectedSubcategory || null,
        price_type: this.price_type,
        deposit_configuration: this.deposit_configuration,
        service_id,
        service_name,
        service_value,
        service_time,
        user_ids
      }

      const buttonUpdateService = this.$refs.buttonUpdateService;
      buttonUpdateService.disabled = true;
      buttonUpdateService.innerHTML = "Salvando...";


      api.axios.post("/api/service/update", objServiceUpdate).catch(function (error) {
        if (error.response.data != undefined) {
          buttonUpdateService.innerHTML = "Salvar serviço";
        }
        console.log("error", error);
        alertResponse(Object.values(error.response?.data?.errors || {}).flat()[0] || error.response?.data?.message || error.response?.data || 'Não foi possível salvar o serviço.', true);
      }).then(function (response) {

        if (response != undefined && response.status == 200) {
          buttonUpdateService.innerHTML = "Serviço salvo com sucesso !";
          window.location.reload();
        } else {
          buttonUpdateService.disabled = false;
          buttonUpdateService.innerHTML = "Salvar serviço";
        }
      });
    },
    alertResponse(message, error) {
      const warningMessage = `<i class="flaticon flaticon-warning"></i> ` + message;
      const successMessage = `<i class="flaticon flaticon-check"></i> ` + message;

      if (error) {
        document.getElementById("errorMessageUpdateService").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdateService").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdateService");
      if (elementAlert) {
        if (error) {

          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }

    },
  }
};
</script>
